import Vue from 'vue';
import Component from 'vue-class-component';
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate' // for vue-router 2.2+
]);
import Router from 'vue-router';

/* tslint:disable */

const Error = () => import('@/base/error/error.vue');
const LogsComponent = () => import('@/services/logs/logs.vue');

const Product = () => import('@/services/product/product.vue');
const ProductDetails = () => import('@/services/product/product-details.vue');
const ProductUpdate = () => import("@/services/product/product-update.vue");

const Query = () => import('@/services/queries/queries.vue');
const QueryUpdate = () => import('@/services/queries/query-update.vue');
const QueryDetails = () => import('@/services/queries/query-details.vue');

const Reports = () => import('@/services/reports/reports.vue');
const ReportsDetails = () => import('@/services/reports/reports-details.vue');

const AggregatedReportsDetails = () => import('@/services/aggregated/aggregated-details.vue');

const Aggregated = () => import('@/services/aggregated/aggregated.vue');

const Uploading = () => import('@/services/uploading/uploading.vue');
const UploadingDetails = () => import('@/services/uploading/uploading-details.vue');

const Revenue = () => import('@/services/revenue/revenue.vue');


Vue.use(Router);

// prettier-ignore
export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Reports
        },
        {
            path: '/product',
            name: 'Products',
            component: Product
        },
        {
            path: '/product/:installationId/view',
            name: 'ProductView',
            component: ProductDetails
        },
        {
            path: '/product/:installationId/edit',
            name: 'ProductEdit',
            component: ProductUpdate
        },
        {
            path: '/queries',
            name: 'Queries',
            component: Query
        },
        {
            path: '/queries/new',
            name: 'QueryCreate',
            component: QueryUpdate
        },
        {
            path: '/queries/:queriesId/edit',
            name: 'QueryEdit',
            component: QueryUpdate
        },
        {
            path: '/queries/:queriesId/view',
            name: 'QueryView',
            component: QueryDetails
        },
        {
            path: '/reports',
            name: 'Reports',
            component: Reports
        },
        {
            path: '/reports/:reportsId/view',
            name: 'ReportsView',
            component: ReportsDetails
        },
        {
            path: '/aggregated',
            name: 'Aggregated',
            component: Aggregated
        },
        {
            path: '/aggregated/view',
            name: 'AggregatedView',
            component: AggregatedReportsDetails
        },
        {
            path: '/uploading',
            name: 'Uploading',
            component: Uploading,
            meta: { authorities: ['cep-revenue'] }
        },
        {
            path: '/uploading/:fileid/view',
            name: 'UploadingDetails',
            component: UploadingDetails,
            meta: { authorities: ['cep-revenue'] }
        },
        {
            path: '/revenue/view',
            name: 'Revenue',
            component: Revenue,
            meta: { authorities: ['cep-revenue'] }
        },
        {
            path: '/not-found',
            name: 'NotFound',
            component: Error,
            meta: { error404: true }
        },
        {
            path: '/forbidden',
            name: 'Forbidden',
            component: Error,
            meta: { error403: true }
        },
        {
            path: '/logs',
            name: 'LogsComponent',
            component: LogsComponent,
            meta: {
                authorities: [
                    'cep-admins'
                ]
            }
        }
    ]
});
